<template>
	<div class="commissions">
		<v-layout row wrap>
			<v-flex xs12 sm12 md9 class="div-container-commissions">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12>
						<div class="div-container-selects">
							<div class="div-container-filters">
								<v-dialog
									ref="dialog"
									v-model="modal"
									:return-value.sync="date"
									persistent
									lazy
									full-width
									width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="date"
											label="Mês "
											prepend-icon="event"
											readonly
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="date" type="month" locale="pt-br" scrollable>
										<v-spacer></v-spacer>
										<v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
										<v-btn flat color="primary" @click="$refs.dialog.save(date)"
											>OK</v-btn
										>
									</v-date-picker>
								</v-dialog>
							</div>
							<div class="div-container-filters-button">
								<button
									:disabled="!!dataLoading"
									v-on:click="refresh"
									class="button-generate-note"
								>
									<v-icon class="material-icons-outlined" size="40">bolt</v-icon>
									<p>Gerar relatório</p>
								</button>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex sm8 md3 class="div-component-header-commissions">
				<Header
					class="hidden-xs-and-down"
				/>
			</v-flex>
			<v-flex xs12 sm12 md9>
				<div class="div-container-dataTable-commissions">
					<v-data-table
						:headers="commissionsHeaders"
						:items="commissionsItems"
						item-key="_id"
						class="elevation-10"
						rows-per-page-text="Itens por página"
						:rows-per-page-items="[10, 100, 500]"
						no-data-text="Sem pagamentos a exibir"
						:loading="dataLoading"
						:total-items="totalCommissionsItems"
						:pagination.sync="pagination"
					>
						<v-progress-linear
							slot="progress"
							color="primary"
							indeterminate
						></v-progress-linear>
						<template slot="items" slot-scope="props">
							<tr
								@click="props.expanded = !props.expanded"
								:style="{ cursor: 'pointer' }"
							>
								<td class="font-weight-black">{{ props.item.timestamp_string }}</td>
								<td class="text-xs-left">{{ props.item.campaign_name }}</td>
								<td class="font-weight-black text-xs-left">
									<span
										v-if="props.item.status == 'Confirmado'"
										style="color: #40DA99 !important"
									>
										{{ props.item.accumulated_value_string }}
									</span>
									<span
										v-else-if="props.item.status == 'Disponivel'"
										style="color: #5191F2 !important"
									>
										{{ props.item.accumulated_value_string }}
									</span>
									<span v-else style="color: #E9EC58 !important">
										{{ props.item.accumulated_value_string }}
									</span>
								</td>
								<td class="font-weight-black text-xs-left">
									<span
										v-if="props.item.status == 'Confirmado'"
										style="color: #40DA99 !important"
									>
										{{ props.item.value_string }}
									</span>
									<span
										v-else-if="props.item.status == 'Disponivel'"
										style="color: #5191F2 !important"
									>
										{{ props.item.value_string }}
									</span>
									<span v-else style="color: #E9EC58 !important">
										{{ props.item.value_string }}
									</span>
								</td>
								<td class="font-weight-black text-xs-left">
									<span
										v-if="props.item.status == 'Confirmado'"
										style="color: #40DA99 !important"
									>
										{{ props.item.total_value_string }}
									</span>
									<span
										v-else-if="props.item.status == 'Disponivel'"
										style="color: #5191F2 !important"
									>
										{{ props.item.total_value_string }}
									</span>
									<span v-else style="color: #E9EC58 !important">
										{{ props.item.total_value_string }}
									</span>
								</td>
								<td class="font-weight-black text-xs-left">
									<span
										v-if="props.item.status == 'Confirmado'"
										style="color: #40DA99 !important"
									>
										{{ props.item.status }}
									</span>
									<span
										v-else-if="props.item.status == 'Disponivel'"
										style="color: #5191F2 !important"
									>
										{{ props.item.status }}
									</span>
									<span v-else style="color: #E9EC58 !important">
										{{ props.item.status }}
									</span>
								</td>
							</tr>
						</template>
						<template slot="expand" slot-scope="props">
							<v-layout row wrap align-space-around justify-center>
								<v-flex xs12 md6 pa-4 class="div-container-click-expand-informations-advertiser">
									<div>
										<span class="title">{{
											props.item.advertiser.register.reg_name
										}}</span>
										<br />
										<br />
										<span v-if="props.item.advertiser.register.reg_code"
											><strong> Pessoa Jurídica </strong>
										</span>
										<br />
										<span>{{ props.item.advertiser.corporate_name }}</span>
										<br />
										<span>{{ props.item.advertiser.register.reg_code }}</span>
									</div>
								</v-flex>
								<v-flex xs12 md6 pa-4 class="div-container-click-expand-informations-advertiser">
									<div>
										<span class="title"
											>{{ props.item.advertiser.address.city }} -
											{{ props.item.advertiser.address.state }}
										</span>
										<br />
										<br />
										<span
											><strong> CEP: </strong>
											{{ props.item.advertiser.address.cep }}</span
										>
										<span></span>
										<br />
										<span
											><strong> Rua: </strong
											>{{ props.item.advertiser.address.street }} -
											<strong> Nº: </strong>
											{{ props.item.advertiser.address.street_n }}
										</span>
										<br />
										<span v-if="props.item.advertiser.address.complement"
											><strong> Complemento: </strong>
											{{ props.item.advertiser.address.complement }}</span
										>
									</div>
								</v-flex>
							</v-layout>
						</template>
					</v-data-table>
				</div>
			</v-flex>
			<v-flex xs12 ml-2>
					<csv-export-button
						v-show="commissionsItems.length > 0"
						:attr_names="csvAttrNames"
						:column_names="csvColumnNames"
						:filename="csvFileName"
						:data="load_commissions_export_csv"
					></csv-export-button>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>

import CsvExportButton from 'magafilio-vue/components/CsvExportButton'
import Header from '../components/Header.vue'
import { affiliate_api } from '@/api'

export default {
	name: 'Commissions',
	mixins: [affiliate_api],
	components: {
		CsvExportButton,
		Header
	},
	data() {
		return {
			totalCommissionsItems: 0,
			modal: false,
			dataLoading: false,
			date: new Date(new Date().getFullYear(), new Date().getMonth() - 1).toISOString().substr(0, 7),
			commissionsHeaders: [
				{
					text: 'Fechamento',
					align: 'left',
					value: 'timestamp',
					width: '20%',
				},
				{ text: 'Campanha', value: 'campaign.reg_name', width: '20%' },
				{ text: 'Acumulado', value: 'accumulated_value', width: '15%' },
				{ text: 'Atual', value: 'value', width: '15%' },
				{ text: 'Total', value: 'valorTotal', width: '15%' },
				{ text: 'Estado', value: 'status', width: '15%' },
			],
			commissionsItems: [],
			csvAttrNames: [
				'campaign_name',
				'accumulated_value_string',
				'value_string',
				'total_value_string',
				'status',
			],
			csvColumnNames: [
				'Campanha',
				'Valor Acumulado',
				'Valor Atual',
				'Valor Total',
				'Estado',
			],
			pagination: {
				sortBy: 'timestamp',
				descending: true,
			},
		}
	},
	computed: {
		affiliate: function () {
			return this.$root.affiliate !== {} ? this.$root.affiliate : {}
		},
		csvFileName: function () {
			return (
				'magafilio_pagamento_' +
				this.date
			)
		},
	},
	methods: {
		add_thousands_sep(x) {
			var parts = x.toString().split(',')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			return parts.join(',')
		},

		to_reais: function (value) {
			return `R$ ${this.add_thousands_sep(value.toFixed(2).replace('.', ','))}`
		},
		load_commissions: async function () {
			const data = this.date
			let _commissions = []
			this.dataLoading = true

			try {

				let _status_dict = {
					issued: 'Disponivel',
					confirmed: 'Confirmado',
					accumulated: 'Acumulado',
				}

				let params = {
					period_end: data,
					start: this.pagination.page,
					limit: this.pagination.rowsPerPage,
					sort_by: this.pagination.sortBy,
					sort_dir: this.pagination.descending ? 'desc' : 'asc',
				}

				if (this.selectedCampaigns) {
					params.cmps = this.selectedCampaigns.reduce(
						(acc, { _id }) => [...acc, _id],
						[]
					)
				}

				let _cmp_com = await this.get_commissions(this.affiliate._id, params)

				_commissions = _cmp_com.data.entries.map((com) => {
					com.timestamp_string = new Date(com.timestamp).toLocaleDateString(
						'pt-BR'
					)
					com.period_start_string = new Date(com.period_start).toLocaleString(
						'pt-BR'
					)
					com.period_end_string = new Date(com.period_end).toLocaleString(
						'pt-BR'
					)

					com.campaign_name = com.campaign.reg_name
					com.status = _status_dict[com.status]
					com.accumulated_value_string = this.to_reais(+com.accumulated_value)
					com.value_string = this.to_reais(+com.value)
					com.total_value_string = this.to_reais(+com.valorTotal)
					return com
				})
				this.totalCommissionsItems = _cmp_com.data.total
			} catch (err) {
				this.$notify({
					type: 'error',
					title: `Erro buscando comissões, ${err}!`,
				})
			}
			this.commissionsItems = _commissions
			this.dataLoading = false
		},
		refresh: function () {
			this.load_commissions()
		},
		load_commissions_export_csv: async function () {
			const data = this.date
			let _commissions = []
			this.dataLoading = true

			try {

				let _status_dict = {
					issued: 'Disponivel',
					confirmed: 'Confirmado',
					accumulated: 'Acumulado',
				}

				let params = {
					period_end: data,
					start: this.pagination.page,
					limit: this.totalCommissionsItems,
					sort_by: this.pagination.sortBy,
					sort_dir: this.pagination.descending ? 'desc' : 'asc',
				}

				if (this.selectedCampaigns) {
					params.cmps = this.selectedCampaigns.reduce(
						(acc, { _id }) => [...acc, _id],
						[]
					)
				}

				let _cmp_com = await this.get_commissions(this.affiliate._id, params)

				_commissions = _cmp_com.data.entries.map((com) => {
					com.timestamp_string = new Date(com.timestamp).toLocaleDateString(
						'pt-BR'
					)
					com.period_start_string = new Date(com.period_start).toLocaleString(
						'pt-BR'
					)
					com.period_end_string = new Date(com.period_end).toLocaleString(
						'pt-BR'
					)

					com.campaign_name = com.campaign.reg_name
					com.status = _status_dict[com.status]
					com.accumulated_value_string = String(com.accumulated_value.toFixed(2))
					com.value_string = String(com.value.toFixed(2))
					com.total_value_string = String(com.valorTotal.toFixed(2))
					return com
				})

			} catch (err) {
				this.$notify({
					type: 'error',
					title: `Erro buscando comissões, ${err}!`,
				})
			}
			this.dataLoading = false
			return _commissions
		},
	},
	watch: {
		pagination: {
			async handler() {
				// await this.load_campaigns()
				await this.load_commissions()
			},
			deep: true,
		},
	},
	created: async function () {
		if (
			Array.isArray(this.$root.advertiserList) &&
			this.$root.advertiserList.length
		) {
			this.advertiser = this.$root.advertiserList[0]
		}
	},
}
</script>

<style>

.div-component-header-commissions div#componente-header {
	position: absolute;
	z-index: 0;
	height: 0vh;
}

div.commissions {
	margin: 55px 10px 95px 10px;
}

.div-container-commissions .div-container-selects {
  margin-top: 25px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-commissions .div-container-selects .div-container-filters {
	width: 80%;
	margin-right: 20px;
}

/* Begin select data */
.div-container-commissions .div-container-selects .div-container-filters  .v-input__prepend-outer {
	margin-top: 12px;
}

.div-container-commissions .div-container-selects .div-container-filters .v-input__slot {
	padding: 0 12px;
}

.div-container-commissions .div-container-selects .div-container-filters .v-input__slot .v-text-field__slot {
	padding-top: 5px;
}

.div-container-commissions .div-container-selects .div-container-filters .v-input__slot .v-label.v-label--active.theme--light {
	top: -2px;
  left: -3px !important;
}

.div-container-commissions .v-menu__activator .v-input.v-text-field.v-input--is-label-active.v-input--is-dirty.v-input--is-focused.v-input--is-readonly.theme--light.primary--text .v-input__prepend-outer i,
.div-container-commissions .v-input__slot .v-text-field__slot .v-label.v-label--active.theme--light
{
	color: #40DA99 !important;
}

.v-picker__title.primary, .v-picker__body.theme--light, .v-picker__actions.v-card__actions {
	background-color: #2D2F32 !important;
}

.v-btn.v-btn--active.v-btn--depressed.theme--light.accent {
	background-color: rgba(0, 0, 0, 0.4) !important;
}

.div-container-filters .v-input__icon.v-input__icon--prepend .v-icon.material-icons.theme--light {
	color: #40DA99 !important;
}

/* End select data */

/* Begin botao gerar relatorio */
.div-container-commissions .div-container-filters-button button.button-generate-note {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px;
	margin-right: 10px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 12px;
	transform: opacity 0.2s;
}

.div-container-commissions .div-container-filters-button button.button-generate-note:hover {
	opacity: 0.5;
}

.div-container-commissions .div-container-filters-button button.button-generate-note p {
	margin: 0px;
	font-size: 14px;
}

.div-container-commissions .div-container-filters-button button.button-generate-note .v-icon.material-icons-outlined.material-icons.theme--light {
	margin-bottom: 5px;
	color: #40DA99 !important;
}

/* end botao gerar relatorio */

/* Begin dataTable */
.div-container-dataTable-commissions {
	margin-right: 20px;
	margin-left: 15px;
	margin-top: 25px;
}

.v-datatable.v-table.theme--light {
	background: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px 13px 0px 0px;
}

.v-datatable__actions  {
	background: #2D2F32 !important;
}

.v-datatable__actions .v-select__slot {
	padding: 0px 12px;
}

.v-select__slot .v-icon.material-icons.theme--light.primary--text {
	color: #40DA99 !important;
}

.v-progress-linear .primary{
	background-color: #40DA99 !important;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: rgba(0,0,0,0.5) !important;
}

.div-container-click-expand-informations-advertiser {
	background: rgba(0,0,0,0.5) !important;
}

/* End dataTable */

</style>
